<ng-container *transloco="let convert;">
  <app-modal [modalId]="modalId">
    @if (!waitingResponse && !successfulResponse) {
      <header class="modal__header">
        <h1 #headerEdit
          class="modal__title"
          [attr.id]="modalId + '-title'"
        tabindex="-1">{{ convert('vehicles.editDealershipModal.textDealership') }}</h1>
      </header>
      @if (errorMessage) {
        <div class="mt-2">
          @if (errorMessage) {
            <p class="mb-0 text-danger fw-bold">{{ errorMessage }}</p>
          }
        </div>
      }
      <div class="modal__content dealership_options">
        <form class="control-wrapper">
          @for (dealer of dealerships; track dealer) {
            <div class="custom-control custom-radio dealership-control-inline"
              >
              <input type="radio"
                id="{{ dealer.oeUuid }}"
                name="dealership-radios"
                title="{{ dealer.oeName }}"
                class="custom-control-input dealership_options__rows--input"
                [checked]="isSelectedDealership(dealer)"
                (change)="updateSelection(dealer)" />
              <label class="custom-control-label dealership_options__label ellipsis-overflow"
                title="{{ dealer.oeName }}"
              for="{{ dealer.oeUuid }}">{{ dealer.oeName }}</label>
            </div>
          }
        </form>
      </div>
      <div class="modal__action">
        <button class="btn btn-primary bid-buttons action-btns"
          [disabled]="!isDealershipChanged"
          (click)="submitDealership()"
          data-track-elem="button"
          data-track-name="Save"
          id="do_save_button"
        #submitSave>{{ convert('common.btnSave') }}</button>
        <button class="btn btn-link cancel-btn bid-buttons action-btns"
          (click)="close()"
          data-track-elem="button"
          data-track-name="Cancel"
          data-track-trigger="close"
          id="do_cancel_button"
        #cancelSave>{{ convert('common.btnCancel') }}</button>
      </div>
      <div class="modal-close-container">
        <button class="modal__close"
          [attr.aria-label]="convert('common.modalClose')"
          (click)="close()"
          data-track-elem="icon"
          data-track-name="Close"
          data-track-trigger="close"
          id="do_close_x_button"
          #closeButton>
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    }
    @if (waitingResponse && !successfulResponse) {
      <!-- submitting -->
      <app-action-submitting actionText="{{ convert('vehicles.editDealershipModal.actionTextSavingDealership') }}"></app-action-submitting>
    }

    @if (!waitingResponse && successfulResponse) {
      <!-- success -->
      <app-action-submitted (close)="close()" actionText="{{ convert('vehicles.editDealershipModal.actionTextDealershipSaved') }}" [tenantName]="tenantName">
      </app-action-submitted>
    }
  </app-modal>

  <app-quote-warning-modal
    [modalId]="modalId + '-quote'"
    (confirmation)="confirmation($event)"
    >
  </app-quote-warning-modal>
</ng-container>
